import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';

export interface AccordionItem {
  question: string;
  answer: string;
}

interface Props {
  item: AccordionItem;
  isActive: boolean;
  scrollToActive: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiAccordionItem',
  props: {
    item: null,
    isActive: { type: Boolean },
    scrollToActive: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({ (e: 'select'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: AccordionItem;
  isActive: boolean;
  scrollToActive: boolean;
};




const question = ref<HTMLElement | null>(null);

const toggle = () => {
  emit('select');
};

watch(
  () => props.isActive,
  () => {
    if (!props.scrollToActive || !props.isActive || !question.value) return;
    question.value.scrollIntoView({
      behavior: 'smooth',
      // @ts-ignore
      alignToTop: true,
    });
  },
);

onMounted(() => {
  if (props.scrollToActive && props.isActive && question.value) {
    question.value.scrollIntoView({
      behavior: 'smooth',
      // @ts-ignore
      alignToTop: true,
    });
  }
});

return { __sfc: true,props, emit, question, toggle }
}

})